import type { Error } from '../types';

export const mustStartWithField =
  (field: string, message?: Error['message']) =>
  (value: string, allValues: Record<string, string>): Error => ({
    valid:
      !value || !allValues[field] || value.toLowerCase().startsWith(allValues[field].toLowerCase()),
    message
  });
